import AppRoute from 'general/constants/AppRoute';
import PreferenceKeys from 'general/constants/PreferenceKeys';
import RoleUtils from 'general/utils/RoleUtils';
import _ from 'lodash';
import { useMemo } from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';

function DashboardRoute({ ...props }) {
  // MARK: --- PROPERTIES ---
  const { user, agencyRoleList } = useSelector((state) => state.auth);
  const savedUiMode = localStorage.getItem(PreferenceKeys.savedUiMode);
  const routeName = useMemo(() => {
    if (RoleUtils.isCustomerUiRole(user?.role, savedUiMode)) {
      return AppRoute.customerHome;
    }

    return RoleUtils.getCmsHomeRoute(user, agencyRoleList);
  }, [user, agencyRoleList, savedUiMode]);

  return _.isEmpty(user) ? <div>Loading...</div> : <Navigate to={routeName} />;
}

export default DashboardRoute;
